import { render, staticRenderFns } from "./authorize.vue?vue&type=template&id=e540b6ce&"
import script from "./authorize.vue?vue&type=script&lang=ts&"
export * from "./authorize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports